import {UNCHANGED_PASSWORD} from '@netx/core-auth-next/constants';
import type {NewUserProfile} from './types';

export enum UserPref {
	SESSION_DURATION = 'user.sessionDuration',
}

export enum UserLevel {
	NO_ACCESS = 0,
	BROWSER = 1,
	CONSUMER = 2,
	IMPORTER = 3,
	PRODUCER = 4,
	MANAGER = 7,
	DIRECTOR = 8,
	ADMIN = 9,
}

export enum UserSource {
	INTERNAL = 0,
	LDAP = 1,
	SAML = 2,
	PING_ONE = 3,
	LIVE_CONNECT = 4,
}

export enum UserPermission {
	READ = 1,
	DOWNLOAD = 2,
	ADD = 3,
	MODIFY = 5,
	DELETE = 7,
	ALL = 9,
}

export enum UserGroupItemType {
	GROUP = 'group',
	USER = 'user',
}

export enum UserImportOption {
	ADD_NEW_USERS_ONLY = 1,
	UPDATE_EXISTING_USERS_ONLY = 2,
	ADD_AND_UPDATE = 3,
	DELETE = 4,
}

export const USER_DEFAULTS: NewUserProfile = {
	address1: '',
	address2: '',
	city: '',
	country: '',
	email: '',
	expirationDate: '',
	groupIds: [] as number[],
	groupNames: [] as string[],
	login: '',
	name1: '',
	name2: '',
	name3: '',
	name4: '',
	notify: 1,
	organization: '',
	password1: UNCHANGED_PASSWORD,
	password2: UNCHANGED_PASSWORD,
	phone1: '',
	phone2: '',
	phone3: '',
	phone4: 'NA',
	propertyNames: [] as string[],
	propertyValues: [] as string[],
	state: 'NA',
	type: 0,
	userSource: 0,
	zip: '',
};
